import { BioScanHero } from '@/components/scans/BioScanHero'
import { BioScanPricing } from '@/components/scans/BioScanPricing'
import { BioScanDetails } from '@/components/scans/BioScanDetails'
import { BioScanIncluded } from '@/components/scans/BioScanIncluded'
import { BioScanNotes } from '@/components/scans/BioScanNotes'

export const ScansPage = () => (
  <>
    <BioScanHero />

    <BioScanPricing />

    <BioScanDetails />

    <BioScanIncluded />

    <BioScanNotes />
  </>
)
